<template>
  <!-- Generate navigation items from a single source of truth to avoid duplication -->
  <v-list-item
    v-for="link in navLinks"
    :key="link.name"
    class="ma-0 pa-0"
    height="23px"
  >
    <router-link
      :to="{ name: link.name }"
      class="text-decoration-none text-white"
      :aria-label="link.label"
      @click="emit('close')"
    >
      <h2>{{ link.label }}</h2>
    </router-link>
  </v-list-item>
</template>

<script lang="ts" setup>
import { getEnabledRoutes } from '@/services/navigation/navigationConfigService'

// Emit an event for the parent to close the drawer when a link is activated.
const emit = defineEmits(['close'])

// Navigation links loaded from config - users can enable/disable routes via navigation.json
const navLinks = getEnabledRoutes()
</script>

	<style lang="scss" scoped>
	h2 {
	  color: white;
	}

	/* Highlight the active route using the primary colour */
	.router-link-active h2 {
	  border-bottom: 2px solid var(--v-primary-base);
	  padding-bottom: 2px;
	}
	</style>
